import { reduxForm } from 'redux-form';
import Component from './SetPasswordFileForm.jsx';

const initialValues = {
  password: '',
};

const SetPasswordFileForm = reduxForm({
  form: 'formSetPasswordFile',
  initialValues,
  enableReinitialize: true,
})(Component);

export default SetPasswordFileForm;
